import { Component, OnInit } from '@angular/core';

import * as firebase from 'firebase/app';

import { AuthService } from '../../service/auth.service';

@Component({
  selector: 'app-email-verification',
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.css']
})
export class EmailVerificationComponent implements OnInit {
  email = 'your email';

  constructor(
    private auth: AuthService
  ) { }

  ngOnInit() {
    this.setUserEmail();
  }

  setUserEmail() {
    if (firebase.auth().currentUser) {
      this.email = firebase.auth().currentUser.email;
    }
  }

  resendEmail() {
    this.auth.sendEmailVerification(false);
  }
}
